import { formatNumber } from 'Utilities'
import { MAESTRO } from '../Constants'
import { CATALOGO_ENDPOINT, DATAMASTER_ENDPOINT } from 'cfgCommon/endpoints'
import { REACT_APP_IMG } from 'cfgCommon/config'

export const getResponseMapped = (val) => {
    return val.map((item) => ({
        label: item.name,
        value: item.id,
        id: item.id,
        data: item?.data
    }))
}

export const getResponseVersionMapped = (val, isUsed) => {
    return val.map((item) => ({
        label: buildLabelVersion(item, isUsed),
        value: item.id,
        id: item.id,
        data: {
            description: isUsed ? buildDescriptionVersion(item.data) : ''
        }
    }))
}

const buildLabelVersion = (item, isUsed) => {
    let label = item.name
    if (item.data) {
        const { symbol, car_lot_name, sale_price, año } = item.data
        if (isUsed) {
            if (año) {
                label = label.concat(` - ${año}`)
            }
            if (sale_price && symbol) {
                label = label.concat(` - ${formatNumber.money(sale_price, symbol)}`)
            }
        } else {
            if (sale_price && symbol) {
                label = label.concat(` - ${formatNumber.money(sale_price, symbol)}`)
            }
            if (car_lot_name) {
                label = label.concat(` - ${car_lot_name}`)
            }
        }
    }
    return label
}

const buildDescriptionVersion = item => item
    ? `${item.car_lot_name} - Km ${formatNumber.separator(item.kilometros)}${
        item.patente
            ? ` - ${item.patente}`
            : ''}`
    : ''

export const getBasePath = origin => origin === MAESTRO ? DATAMASTER_ENDPOINT : CATALOGO_ENDPOINT

export const getThumbnail = (files, isLogo) => {
    let url = '', thumbnail = ''
    if (files) {
        const imageFiles = files.filter(file => file.type.name.includes('image/'))
        if (imageFiles && imageFiles[0]) {
            if (imageFiles[0].thumbnail && !isLogo) {
                url = imageFiles[0].url.replace(
                    imageFiles[0].name,
                    'th-' + imageFiles[0].name
                )
            } else {
                url = imageFiles[0].url
            }
            thumbnail = getUrlThumbnail(url)
        }
    }
    return thumbnail
}

const getUrlThumbnail = file => `${REACT_APP_IMG}/${encodeURIComponent(file)}`

export const scrollToStart = () => {
    const contentContainer = document.querySelector('.header-content-bg') 
    contentContainer.scrollTo({top: 0, behavior: 'smooth'})
}